export const SET_FLAGS = 'SET_FLAGS'
export const SET_DADOS_RETORNO_CADASTRO = 'SET_DADOS_RETORNO_CADASTRO'
export const SET_CARREGANDO_DADOS = 'SET_CARREGANDO_DADOS'
export const SET_MANIPULANDO_DADOS = 'SET_MANIPULANDO_DADOS'
